import Repository from "@/api/repository";
const resource = `/scanplanusage/totalscansperuser`;
export default {
    getTotalScansPerUser() {
        return Repository.get(`${resource}`);
    }
};
